import { render, staticRenderFns } from "./ExperienceLevelBadge.vue?vue&type=template&id=557dad2c&scoped=true&"
import script from "./ExperienceLevelBadge.vue?vue&type=script&lang=js&"
export * from "./ExperienceLevelBadge.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceLevelBadge.vue?vue&type=style&index=0&id=557dad2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557dad2c",
  null
  
)

export default component.exports